/* YourAgentsSkeleton.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._42d1HAmdCj%7Brow-gap%3A56px%7D");
import React from 'react';
import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import type { SkeletonProps } from '../../types';
import { CardListSkeleton } from '../CardListSkeleton/CardListSkeleton';
const styles = {
  sections: "_42d1HAmdCj"
};
export const YourAgentsSkeleton = ({
  testId
}: SkeletonProps): React.JSX.Element => {
  const isUplift = expVal('jira_browse_agent_modal_update', 'isEnabled', false);
  return <Stack space={isUplift ? undefined : 'space.400'} xcss={isUplift && styles.sections}>
			<CardListSkeleton count={4} showHeading testId={testId ? `${testId}--owned` : undefined} />
			<CardListSkeleton count={4} showHeading testId={testId ? `${testId}--starred` : undefined} />
		</Stack>;
};